import userFavouriteProducts from '../store/UserFavouriteProducts.js';


App.D.ready(function() {
    let $productOffers = $('.js-product-offers');
    let currProductOption = $productOffers.find(`option[value="${$productOffers.val()}"]`);
    let currProductPrice = currProductOption.data('price');
    let currProductId = currProductOption.data('product-id');
    let $currProduct = $productOffers.closest('.js-store-product');
    let toBasketClass = '.js-to-basket';
    let toFavouriteClass = '.js-to-favorite';
    let toRemoveClass = '.js-product-remove';
    let messageMeClass = '.js-message-me';
    let orderToBasketClass = '.js-order-to-basket';

    if ($(currProductOption).length > 0) {
        productSelectStates($(currProductOption));
    }

    $productOffers.on('change', function() {
        currProductOption = $productOffers.find(`option[value="${$productOffers.val()}"]`);
        currProductId = currProductOption.data('product-id');
        currProductPrice = currProductOption.data('price');

        productSelectStates($(currProductOption));
    });

    App.D.on('click', toBasketClass, function(e) {
        e.preventDefault();

        let btn = $(this);
        let action = btn.data('action');

        if (!$productOffers.length) {
            currProductId = btn.closest('.js-store-product').data('product-id');
            $currProduct = $('.content').find(('.js-store-product[data-product-id="' + currProductId + '"]'));
        }

        $.ajax({
            method: "GET",
            url: btn.data('url'),
            dataType: "json",
            data: {
                'id': currProductId,
                'price': currProductPrice,
                'action': action
            },
            success: (response) => {
                if (response.success) {
                    btn.addClass('_in-basket-btn');
                    $currProduct.find(toBasketClass).addClass('_in-basket-btn');
                    $('.js-header-basket').removeClass('header-basket--empty');
                    $('.js-basket-quantity').html(limitMaximum(response.quantity));
                    $currProduct.find('.js-product-item-bottom').addClass('_in-basket');
                    $(currProductOption).data('in-basket', 1);
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    });

    App.D.on('click', toFavouriteClass, function(e) {
        e.preventDefault();

        let btn = $(this);
        let action = 'favorite';

        if (!$productOffers.length) {
            currProductId = btn.closest('.js-store-product').data('product-id');
            $currProduct = $('.content').find(('.js-store-product[data-product-id="' + currProductId + '"]'));
        }

        if (btn.hasClass('_in-favorite')) {
            action = 'notFavorite';
        }

        $.ajax({
            method: "GET",
            url: btn.data('url'),
            dataType: "json",
            data: {
                'id': currProductId,
                'action': action
            },
            success: (response) => {
                if (response.success) {
                    if (response.favouriteIDs.length > 0) {
                        $('.js-header-favorite').addClass('_in-favorite');
                    } else {
                        $('.js-header-favorite').removeClass('_in-favorite');
                    }

                    if (!btn.hasClass('_in-favorite')) {
                        btn.addClass('_in-favorite');
                        $currProduct.find(toFavouriteClass).addClass('_in-favorite');

                        if (btn.hasClass('single-product__link')) {
                            btn.html('В избранном <svg class="sym-icon-favorite-active"><use xlink:href="#sym-icon-favorite-active"></use></svg>')
                        }
                    } else {
                        btn.removeClass('_in-favorite');
                        $currProduct.find(toFavouriteClass).removeClass('_in-favorite');

                        if (btn.hasClass('single-product__link')) {
                            btn.html('В избранное <svg class="sym-icon-favorite"><use xlink:href="#sym-icon-favorite"></use></svg>')
                        }
                    }

                    if ($('.js-products-wrapper').length) {
                        window.userFavourites = {
                            productIDs: response.favouriteIDs
                        }
                        // window.userFavourites.productIDs = response.favouriteIDs;
                        userFavouriteProducts();
                    }
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    });

    App.D.on('click', toRemoveClass, function(e) {
        let btn = $(this);
        currProductId = btn.closest('.js-store-product').data('product-id');

        $.ajax({
            method: "GET",
            url: btn.data('url'),
            dataType: "json",
            data: {
                'id': currProductId,
                'action': 'remove'
            },
            success: (response) => {
                if (response.success) {
                    btn.closest('.js-store-product').remove();

                    if (response.quantity === 0) {
                        $('.js-header-favorite').removeClass('_in-favorite');
                        $('.order-block--favourite').hide();
                        $('.cabinet-favourite__more ').hide();
                    }
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    });

    App.D.on('click', orderToBasketClass, function(e) {
        let btn = $(this);
        let order = btn.closest('.js-old-order');
        let orderId = order.data('order-id');

        $.ajax({
            method: "GET",
            url: btn.data('url'),
            dataType: "json",
            data: {
                'orderId': orderId,
                'action': 'orderToBasket'
            },
            success: (response) => {
                if (response.success) {
                    $('.js-header-basket').removeClass('header-basket--empty');
                    $('.js-basket-quantity').html(limitMaximum(response.quantity));
                    btn.addClass('_in-basket-btn');
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    });

    App.D.on('click', messageMeClass, function(e) {
        let btn = $(this);
        let popupName = btn.data('popup-name');
        let notificationType = btn.data('notification') ? btn.data('notification') : 'productAvailability';
        currProductId = btn.closest('.js-store-product').data('product-id');

        $.ajax({
            method: "GET",
            url: btn.data('url'),
            dataType: "json",
            data: {
                'id': currProductId,
                'action': 'notification',
                'notificationType': notificationType
            },
            success: (response) => {
                if (response.success) {
                    $('.js-product-available').attr('data-product-message', currProductId);
                    $('.js-message-me-id').val(currProductId);
                    App.D.trigger('popup:open', {
                        name: popupName
                    });
                    $('.js-product-available').find('.js-submit').attr('disabled', false).removeClass('_disabled');

                    if (response.email) {
                        $('.js-message-me-email').parents('.js-input-wrap').addClass('_filled');
                        $('.js-message-me-email').val(response.email);
                    }
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    });

    userFavouriteProducts();

    // на планшете и мобилке фиксированная плашка с кнопкой
    // переносится в подвал при скролле страницы до низа
    let $actionsBlock = App.H.find('.js-product-actions');
    const $actionsBlockParent = $actionsBlock.closest('.product-card-cart');
    const $footer = $('.footer');

    if ($actionsBlock.length && $actionsBlockParent.length && $footer.length) {
        if (App.W.width() < 1024) {
            $footer.css('padding-top', $actionsBlock.outerHeight());
            App.W.on('scroll', function() {
                const scrollTop = App.W.scrollTop();

                if (scrollTop + App.W.height() >= $footer.offset().top + $actionsBlock.outerHeight()) {
                    $actionsBlock = App.H.find('.js-product-actions');
                    $footer.prepend($actionsBlock);
                    $actionsBlock.addClass('_bottom-fixed');
                } else {
                    $actionsBlock = App.H.find('.js-product-actions');
                    $actionsBlockParent.append($actionsBlock);
                    $actionsBlock.removeClass('_bottom-fixed');
                }
            });
        } else {
            $actionsBlockParent.append($actionsBlock);
            $actionsBlock.removeClass('_bottom-fixed');
        }

        App.W.on('scroll', function() {
            if (App.W.width() >= 1024) {
                $actionsBlockParent.append($actionsBlock);
                $actionsBlock.removeClass('_bottom-fixed');
            }
        })
    }
});


export function limitMaximum(num) {
    $('.js-basket-quantity').toggleClass('_limit', num > 9);
    return num > 9 ? '9+' : num;
}

// Разные проверки по атрибутам в селекте
function productSelectStates(currProductOption) {
    let toBasketClass = '.js-to-basket';
    let messageMeClass = '.js-message-me';
    let $priceWrap = $('.js-price-wrap');
    let $notPriceWrap = $('.js-not-price');
    let $notDeliveryWrap = $('.js-not-delivery');
    let $productPrice = $('.js-price-store');
    let $oldProductPriceEl = $('.js-old-price');
    let $discountProductValueEl = $('.js-discount-value');
    let currProductPrice = currProductOption.data('price');
    let oldProductPrice = currProductOption.data('old-price') ? currProductOption.data('old-price') : currProductPrice;
    let discountProductValue = currProductOption.data('discount-value');

    // Устанавливаем цену по атрибутам
    $productPrice.text(currProductPrice);
    $oldProductPriceEl.text(oldProductPrice);
    $discountProductValueEl.text(discountProductValue);

    // Если в атрибутах цена 0 или снято с продаж, то убираем кнопки и показываем "Нет в наличии"
    if (currProductPrice === 0 || currProductOption.is('[data-out-of-stock]')) {
        $('.js-price-discount').addClass('hidden');
        $priceWrap.addClass('hidden');
        $(toBasketClass).addClass('hidden');
        $(messageMeClass).addClass('hidden');
        $('.js-product-quantity').addClass('hidden');
        $notPriceWrap.removeClass('hidden');
        $notDeliveryWrap.addClass('hidden');
        $notPriceWrap.find($(messageMeClass)).removeClass('hidden');
    } else {
        if (discountProductValue) {
            $('.js-price-discount').removeClass('hidden');
        } else {
            $('.js-price-discount').addClass('hidden');
        }
        $priceWrap.removeClass('hidden');
        $(toBasketClass).removeClass('hidden');
        $(messageMeClass).removeClass('hidden');
        $('.js-product-quantity').removeClass('hidden');
        $notPriceWrap.addClass('hidden');
        $notDeliveryWrap.removeClass('hidden');
    }

    // Если есть атрибут, что товар в наличии, то меняем "В корзину" на количество
    console.log('currProductOption', currProductOption);
    if (currProductOption.data('in-basket')) {
        let quantity = currProductOption.data('in-basket');

        $(toBasketClass).addClass('_in-basket-btn');
        $('.js-quantity-input').val(quantity);
    } else {
        $(toBasketClass).removeClass('_in-basket-btn');
        $('.js-quantity-input').val(1);
        console.log('------------');
    }
}
